export default __webpack_public_path__ + "static/media/bq-se.5cd06e5d.svg";